import { Box, Button, Card, Checkbox, Container, FormLabel, Stack, TextField, Typography } from '@mui/material';
import React, { useEffect, useState } from 'react';
import { Helmet } from 'react-helmet-async';
import { useNavigate, useLocation } from 'react-router-dom';
import { FaArrowLeftLong } from 'react-icons/fa6';
import { SlCloudUpload } from 'react-icons/sl';
import Swal from 'sweetalert2';
import { LoadingButton } from '@mui/lab';

import {
  createDooSetting,
  getDoorSetting,
  deleteUploads,
  getBanner,
  getContactInfo,
  uploadFile,
} from '../helper/backend_helper';
import appConfig from '../config';
import InfoTooltip from '../components/InfoTooltip';
// import logo from 'src/components/logo';

const DoorSettingPage = () => {
  const [bannerData, setBannerData] = useState({});

 
  const [distance, setDistance] = useState(0);
  const [isCloseToDoor, setIsClosedToDoor] = useState(false);


  const [loading, setLoading] = useState(false);
  const handleCheckboxChange = (event) => {
    setIsClosedToDoor(event.target.checked);
  };
 

  const Banner = async () => {
    try {
      const bannerResponse = await getDoorSetting();
      setBannerData(bannerResponse?.data?.data);
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    Banner();
  }, []);
  useEffect(() => {
    setDistance(bannerData?.distance || 0);
    setIsClosedToDoor(bannerData?.isCloseToDoor || false);
  
  }, [bannerData]);

  const handleSave = async () => {
    try {
      setLoading(true);

      
      const BannerData = {
        distance,
        isCloseToDoor,
      };

      const Categoryheaders = {
        headers: {
          'Content-Type': 'application/json',
        },
      };

      const response = await createDooSetting(BannerData, Categoryheaders);

      // setTitle('');
      // setFormData({
      //   ...formData,
      //   profileImage: null,
      // });

      // Show success message
      Swal.fire({
        icon: 'success',
        title: 'Door Settings updated successfully',
      });

      setLoading(false);
    } catch (error) {
      console.error('Error:', error);
      setLoading(false);
      Swal.fire({
        icon: 'error',
        title: 'Error',
        text: 'Error while updating Door Settings',
      });
    }
  };

  return (
    <>
      <Helmet>
        <title> Door Settings </title>
      </Helmet>
      <Card sx={{ padding: 3 }}>
        <Stack
          // onClick={() => navigate(-1)}
          gap={3}
          sx={{ cursor: 'pointer' }}
          direction="row"
          alignItems="center"
          justifyContent="flex-start"
        >
          <Typography variant="h4">
            Doors Default Settings{' '}
            <InfoTooltip
              width={20}
              title="The default unlock rules applied to every door in the property. They control whether a guest must be physically near a door to open it and the maximum distance in metres that still counts as close enough. Set the values here and Update to apply them across all doors; individual doors can still be overridden from their own door settings."
            />
          </Typography>
        </Stack>
        <Typography mb={3} variant="h6">This settings will be applied to all the doors, you can modify each door individually from the door settings</Typography> 

        <Box
          component="form"
          sx={{
            '& .MuiTextField-root': { width: '50ch' },
          }}
          noValidate
          autoComplete="off"
        >
            <Stack sx={{ marginTop: 2, display: 'flex', flexDirection: 'row', gap: 1 }}>
            <Typography variant="h6" mt={1}>
            Guest needs to be close to the door to open it:
            </Typography>
            <Checkbox checked={isCloseToDoor} onChange={handleCheckboxChange} />
          </Stack>
          <Stack mt={1} spacing={{ xs: 2, sm: 4 }} direction="row" useFlexGap flexWrap="wrap">

            <Stack>
              <FormLabel sx={{ mb: 1 }}>Distance (m)<InfoTooltip title="Maximum distance in metres a guest may be from the door and still be allowed to unlock it." /></FormLabel>
              <TextField
              type='number'
                label="Enter Distance (m"
                id="outlined-size-small"
                value={distance}
                onChange={(e) => setDistance(e.target.value)}
              />
            </Stack>
          </Stack>
        
      
      

       

       
        
         
         
         
        </Box>
        <LoadingButton
          sx={{
            // width: 150,
            mt: 4,
            mb: 4,
            boxShadow: 'none',
            backgroundColor: '#1E3A5F',
            '&:hover': {
              backgroundColor: '#1E3A5F',
              boxShadow: 'none',
            },
          }}
          variant="contained"
          onClick={handleSave}
          loading={loading}
        >
          Update
        </LoadingButton>
      </Card>
    </>
  );
};

export default DoorSettingPage;
